export default {
  currentFolderSelection: null,
  currentFile: null,
  moveFileDialog: false,
  copyFileDialog: false,
  deleteFileDialog: false,
  duplicateFileDialog: false,
  renameFileDialog: false,
  documentsTable: {
    loading: false,
    currentFolderPath: '/',
    currentFolder: null,
    breadcrumbs: [],
    navigationFolderHistory: []
  },
  dialogDocumentsTable: { // dialog document table requires separate state
    loading: false,
    folders: [],
    currentFolderPath: '/',
    currentFolder: null,
    breadcrumbs: [],
    navigationFolderHistory: []
  },
  selectedAttachments: [],
  allFileCheckboxSelected: false
}
